import React, { useState, useEffect } from "react";
import PlaylistItem from "../PlaylistItem";
import ToggleButton from "../../../shared/components/ToggleButton";
import { useReactAppState } from "../../../shared/containers/utils";

const VideoPlaylist = ({ isVideoPlaying, playerHeight, videoList, currentVideoID, updateVideo, showLoadMore }) => {
  const { t } = useReactAppState();
  const [videos, setVideos] = useState(showLoadMore ? videoList.slice(0, 6) : videoList);
  const [allVideosLoaded, setAllVideosLoaded] = useState(false);

  const handleVideoList = () => {
    setAllVideosLoaded(true);
    setVideos(videoList);
  };

  useEffect(() => {
    showLoadMore && !allVideosLoaded
      ? setVideos(videoList.slice(0, 6))
      : setVideos(videoList);
  }, [showLoadMore]);

  return (
    <div style={playerHeight ? { maxHeight: `${playerHeight}px` } : {}} className="mls-c-video-component__playlist">
      {
        videos.map((video, index) => {
          const isCurrentVideo = video?.fields?.brightcoveId === currentVideoID;
          return <PlaylistItem isVideoPlaying={isVideoPlaying} item={video} key={`${video._entityId}-${index}`} isCurrentItem={isCurrentVideo} index={index} updateVideo={updateVideo} />;
        })
      }
      {
        showLoadMore && !allVideosLoaded
          ? (
            <div className="mls-c-video-component__load-more">
              <ToggleButton className="mls-o-buttons__basic mls-o-buttons__basic--dark" onClick={() => handleVideoList()}>{t("brightcove_load_more")}</ToggleButton>
            </div>
          )
          : null
      }
    </div>
  );
};

export default VideoPlaylist;
